import { Routes } from 'config/routes';
import { UserRole } from 'gql/types';
import { RouteType } from 'modules/auth/enums';
import { IModule } from 'modules/common/interfaces';

import NightlyCountPage from './pages/NightlyCount';

const ACCESS_ROLES: UserRole[] = [
  UserRole.Admin,
  UserRole.MedicalDirector,
  UserRole.Dvm,
  UserRole.Operations,
  UserRole.RegionalUser,
  UserRole.TeamLead,
  UserRole.Phlebotomist,
  UserRole.CanineHandler,
];

const nightlyCountModule: IModule = {
  routes: [
    {
      path: Routes.NightlyCount,
      Component: NightlyCountPage,
      type: RouteType.Auth,
      roles: ACCESS_ROLES,
    },
    {
      path: Routes.NightlyCountEnter,
      Component: NightlyCountPage,
      type: RouteType.Auth,
      roles: ACCESS_ROLES,
    },
    {
      path: Routes.NightlyCountHistory,
      Component: NightlyCountPage,
      type: RouteType.Auth,
      roles: ACCESS_ROLES,
    },
  ],
};

export default nightlyCountModule;
